/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { GridRowModes, GridActionsCellItem } from "@mui/x-data-grid";
import axios from "axios";

function PriceList() {
  const navigate = useNavigate();
  const [rowModesModel, setRowModesModel] = useState({});
  const [priceRowData, setPriceRowData] = useState([]);
  const [priceRowUpdated, setPriceRowUpdated] = useState({});
  const handleEditClick = (_id) => () => {
    setRowModesModel({ ...rowModesModel, [_id]: { mode: GridRowModes.Edit } });
  };
  const handleEditData=(id)=>{
    console.log(priceRowUpdated,'updated2')
    axios.put(`${process.env.REACT_APP_BASE_URL}/priceConverter/updatePriceConverter/${id}`,priceRowUpdated)
  }
  const handleDelete=async(id)=>{
    await axios.delete(`${process.env.REACT_APP_BASE_URL}/priceConverter/deletePriceConverter/${id}`);
    deliveryPriceListFetch();
  }
  const handleCancelClick = (_id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [_id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  const handleRowUpdate=async(newRow)=>{
    console.log(newRow,'NEW ROW UPDATE');
     setPriceRowUpdated({...newRow});
    console.log(priceRowUpdated,newRow,'updated1')
    axios.put(`${process.env.REACT_APP_BASE_URL}/priceConverter/updatePriceConverter/${newRow._id}`,newRow)


    handleEditData(newRow._id);
  }
  const deliveryPriceListFetch = () =>{
    axios.get(`${process.env.REACT_APP_BASE_URL}/priceConverter/fetchPriceConverter"`).then((res) => {
      console.log(res.data.priceConverter,'REEEE');
      setPriceRowData(res.data.priceConverter);
    });
  }
  useEffect(()=>{
    deliveryPriceListFetch();
  },[])
  const price_data = {
    Countries: "",
    Region: "",
    "Train Size Price": "1000",
    "Train Weight Price": "200",
    "Air Size Price": "3000",
    "Train Weight Price": "28",
    Tax: "0.4",
    "Currency Symbol": "c",
    "Currency Value": "1",
    Status: "Active",
  };

  const columns = [
    { field: "_id", headerName: "ID", width: 90 },
    
    
    {
        field: "from",
        headerName: "From",
        width: 150,
    },
    {
      field: "to",
      headerName: "To",
      width: 150,
      // editable:true,
      
    },
    {
      field: "price",
      headerName: "Price",
      width: 150,
      editable: true,
    },

    // {
    //   field: "role",
    //   headerName: "Status",
    //   width: 220,
    //   editable: true,
    //   type: "singleSelect",
    //   valueOptions: ["Enable", "Disable"],
    // },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip title="Delete">
                <IconButton 
                onClick={()=>handleDelete(param.row._id)}
                // onClick={()=>console.log(param.row._id,'OOOO')}
                >
                  <MdDelete style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Quick Edit",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        let isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "green",
              }}
              onClick={() => {
                isInEditMode=false;
                const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
                  if (key !== "image") {
                    acc[key] = value;
                  }
                  return acc;
                }, {});
                console.log(rowWithoutImage);
                const updatedRowModesModel = { ...rowModesModel, [params.id]: { mode: GridRowModes.View }};
                setRowModesModel(updatedRowModesModel);

                // handleEditData(params.row._id);
                // handleSubmit(params.id, rowWithoutImage);
                // window.location.reload();
              }}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(params.id)}
              color="inherit"
            />,
          ];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon className="text-blue-400" />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />,
        ];
      },
    //   valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  
  console.log(priceRowData,'PPPP')
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box sx={{ height: 595, width: "100%", background: "white" }}>
          <DataGrid
            getRowId={(row) => row?.to}
            rows={priceRowData}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
          
            rowModesModel={rowModesModel}
            processRowUpdate={handleRowUpdate}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PriceList;
